export default store => next => action => {
  if (typeof action !== 'function') {
    const { notTrackable, type } = action;
    if (!notTrackable && (global as any).gtag) {
      (global as any).gtag('event', type, {
        event_category: 'action'
      });
    }
  }
  return next(action);
};



// WEBPACK FOOTER //
// ./src/shared/tracking.ts